import type { CopyShape } from "@tami/core/intl";

import type { LEGAL_COPY_PT_BR } from "../legal.copy";

export const LEGAL_COPY_EN_US: CopyShape<typeof LEGAL_COPY_PT_BR> = {
  terms: {
    title: "Terms of Use",
    description:
      "The terms that govern your use of Tãmi: plans, billing, renewal, refunds, cancellation, your account and responsibilities.",
  },
  privacy: {
    title: "Privacy Policy",
    description:
      "How Tãmi collects, uses, shares and deletes your data, on what legal basis, and what your rights over it are.",
  },
};
